import {
  apiRequest,
  cp3kCreate,
  cp3kPeriodDetail,
  cp3kGetProjection,
  masterRegion,
  masterEducation,
  masterRankPppk,
  masterPositionPppk,
  masterWorkUnit,
  masterMaritalStatus,
  masterBank,
  masterReligion,
  cp3kList,
  cp3kDetail,
  cp3kDelete,
  cp3kCreateDecreeCollective,
  cp3kDetailDecreeCollective,
  cp3kDownloadDraftSK,
  cp3kDownloadSKCollective,
  cp3kImportExcel,
} from "../../../../../services/adapters/kepegawaian/cp3kService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      cp3kCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchDetailPeriod = async (query) => {
    return await apiRequest(
      "get",
      cp3kPeriodDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchGetProjection = async (query) => {
    return await apiRequest(
      "get",
      cp3kGetProjection,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchEducation = async (query) => {
    return await apiRequest(
      "get",
      masterEducation,
      {
        params: query,
      },
      true
    );
  };

  fetchRank = async (query) => {
    return await apiRequest(
      "get",
      masterRankPppk,
      {
        params: query,
      },
      true
    );
  };

  fetchPosition = async (query) => {
    return await apiRequest(
      "get",
      masterPositionPppk,
      {
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchMaritalStatus = async (query) => {
    return await apiRequest(
      "get",
      masterMaritalStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchBank = async (query) => {
    return await apiRequest(
      "get",
      masterBank,
      {
        params: query,
      },
      true
    );
  };

  fetchReligion = async (query) => {
    return await apiRequest(
      "get",
      masterReligion,
      {
        params: query,
      },
      true
    );
  };

  fetchListCandidate = async (query) => {
    return await apiRequest(
      "get",
      cp3kList,
      {
        params: query,
      },
      true
    );
  };

  fetchDetailCandidate = async (query) => {
    return await apiRequest(
      "get",
      cp3kDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchDeleteCandidate = async (query) => {
    return await apiRequest(
      "post",
      cp3kDelete,
      {
        body: query,
      },
      true
    );
  };

  fetchCreateDecreeCollective = async (query) => {
    return await apiRequest(
      "post",
      cp3kCreateDecreeCollective,
      {
        body: query,
      },
      true
    );
  };

  fetchDetailDecreeCollective = async (query) => {
    return await apiRequest(
      "get",
      cp3kDetailDecreeCollective,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadDraftSK = async (query) => {
    return await apiRequest(
      "get",
      cp3kDownloadDraftSK,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadSKCollective = async (query) => {
    return await apiRequest(
      "get",
      cp3kDownloadSKCollective,
      {
        params: query,
      },
      true
    );
  };

  fetchImportExcel = async (query) => {
    return await apiRequest(
      "post",
      cp3kImportExcel,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
